import { useTranslation } from "react-i18next";

import { Text } from "components";

import DashboardMessagesContent from "../shared/DashboardMessagesContent";

import shellClasses from "./SectionShell.module.css";

interface MessagesSectionProps {
  className?: string;
}

const joinClasses = (...values: Array<string | false | null | undefined>) =>
  values.filter(Boolean).join(" ");

const MessagesSection = ({ className }: MessagesSectionProps) => {
  const { t } = useTranslation();

  return (
    <section className={joinClasses(shellClasses.root, className)}>
      <div className={shellClasses.header}>
        <Text className={shellClasses.title}>{t("header.chat")}</Text>
      </div>

      <div className={shellClasses.body}>
        <DashboardMessagesContent />
      </div>
    </section>
  );
};

export default MessagesSection;
